const header = {
    cartQty: () => {
        const total = window.$('.cart-toggle .icon-shopping-cart').text().trim()
        return parseInt(total)
    }
}

export default header



// WEBPACK FOOTER //
// ./non-pwa/pages/header.js